module.exports = __webpack_public_path__ + "img/active-19.88b93eef.svg";